'use client';

import { initPerformanceLogging } from '@/lib/logger/pino-logger.client';
import { useEffect } from 'react';

interface IHandlerPerformanceLoggerProps {
  enabled: boolean;
}

export const HandlerPerformanceLogger = ({ enabled }: IHandlerPerformanceLoggerProps) => {
  useEffect(() => {
    if (!enabled) return;
    initPerformanceLogging();
  }, [enabled]);

  return null;
};
